import React from 'react';
import { useNavigate } from 'react-router-dom';
import ErrorMessageComponent from '../error-message/error-message.component';
import ButtonPrimaryComponent from '../button-primary/button-primary.component';
import { IStackStyles, Stack, StackItem } from '@fluentui/react';
import useAuthStatus from '../../hooks/auth/AuthHook';

const stackFooterStyles : IStackStyles = {
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
};

interface INoPermissionComponentProps {
    showButton: boolean;
};

const NoPermissionComponent = (props: INoPermissionComponentProps) => {
    const auth = useAuthStatus();
    const navigate = useNavigate();

    const onGoToHome = () => {
        if (!auth.user) {
            navigate("/");
        }
        else {
            if (!auth.user.UsuarioAdmin) {
                navigate("/main/ordenes-trabajo");
            }
            else {
                navigate("/main/resumen-actividad");
            }
        }
    };

    return (
        <Stack horizontal={false}>
            <StackItem>
                <ErrorMessageComponent message="No posee permisos para acceder a esta sección" />
            </StackItem>
            {
                props.showButton ? (
                    <StackItem>
                        <Stack horizontal={true} styles={stackFooterStyles}>
                            <StackItem>
                                <></>
                            </StackItem>
                            <StackItem>
                                <ButtonPrimaryComponent text="Ir a inicio" onClick={onGoToHome} />
                            </StackItem>
                        </Stack>
                    </StackItem>
                ) : (
                    null
                )
            }
        </Stack>
    );
};

export default NoPermissionComponent;
